// extracted by mini-css-extract-plugin
export default {"section-wrapper":"section-wrapper--mp-RRFfE","sectionWrapper":"section-wrapper--mp-RRFfE"};